export default "__VITE_ASSET__DlnMGCI3__"